import './mutators/onAfterUnsubscribeFromInfobar';
import './mutators/onAfterUnsubscribeFromPersonaCardRemoveInfoBar';

import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import ItemId from 'owa-service/lib/contract/ItemId';
import Message from 'owa-service/lib/contract/Message';
import { ActionSource } from 'owa-mail-store';
import { ArchiveMailListRowsFromTableState } from './actions/archiveMailListRows';
import { ClientItemId } from 'owa-client-ids';
import { DeleteItemFromReadingPaneState } from './actions/deleteItems';
import { EmptyTableViewState } from './actions/emptyTableView';
import { Folder } from 'owa-folders';
import { InstrumentationContext } from 'owa-mail-store';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { MailboxInfo } from 'owa-client-ids';
import { MarkItemJunkNotJunkFromReadingPaneState } from './actions/markAsJunk/markItemJunkNotJunkFromReadingPane';
import { SweepOptionType } from 'owa-mail-sweep-store';
import { TableView } from 'owa-mail-list-store';
import { UnsubscribeEmailState } from './actions/unsubscribeEmail';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TriageAction", webpackPrefetch: true */ './lazyIndex')
);

export let lazyAddMailboxToSafeSenders = new LazyImport(lazyModule, m => m.addMailboxToSafeSenders);

export let lazyAlwaysMoveRowToFocusedOrOther = new LazyAction(
    lazyModule,
    m => m.alwaysMoveRowToFocusedOrOther
);

export let lazyMoveMailListRowsToFocusedOrOther = new LazyAction(
    lazyModule,
    m => m.moveMailListRowsToFocusedOrOther
);

export let lazyDeleteMailListRows = new LazyAction(lazyModule, m => m.deleteMailListRows);

export let lazyDeleteItems = new LazyAction(lazyModule, m => m.deleteItems);

export let lazyDeleteItemsBasedOnNodeIds = new LazyImport(
    lazyModule,
    m => m.deleteItemsBasedOnNodeIds
);

export let lazyLikeItem = new LazyImport(lazyModule, m => m.likeItem);

export let lazyToggleRowsFlagState = new LazyAction(lazyModule, m => m.toggleRowsFlagState);

export let lazySetMailListRowsFlagState = new LazyAction(
    lazyModule,
    m => m.setMailListRowsFlagState
);

export let lazySetItemsFlagStateFromItemIds = new LazyAction(
    lazyModule,
    m => m.setItemsFlagStateFromItemIds
);

export let lazySetItemsFlagStateBasedOnNodeIds = new LazyImport(
    lazyModule,
    m => m.setItemsFlagStateBasedOnNodeIds
);

export let lazyMoveItemsFromItemIds = new LazyAction(lazyModule, m => m.moveItemsFromItemIds);
export let lazyMoveItemsBasedOnNodeIds = new LazyImport(lazyModule, m => m.moveItemsBasedOnNodeIds);
export let lazyMoveMailListRows = new LazyAction(lazyModule, m => m.moveMailListRows);
export let lazyCopyMailListRows = new LazyAction(lazyModule, m => m.copyMailListRows);
export let lazyArchiveMailListRows = new LazyAction(
    lazyModule,
    m => m.archiveMailListRowsFromTable
);

export let lazyScheduleRows = new LazyImport(lazyModule, m => m.scheduleRows);

export let lazyToggleRowPinnedState = new LazyAction(lazyModule, m => m.toggleRowPinnedState);
export let lazyMarkRowsPinnedUnpinned = new LazyAction(lazyModule, m => m.markRowsPinnedUnpinned);
export let lazyMarkRowsJunkNotJunk = new LazyAction(
    lazyModule,
    m => m.markRowsJunkNotJunkFromTable
);
export let lazyMarkItemsJunkNotJunkBasedOnNodeIds = new LazyImport(
    lazyModule,
    m => m.markItemsJunkNotJunkBasedOnNodeIds
);
export let lazyMarkItemJunkNotJunkFromReadingPane = new LazyAction(
    lazyModule,
    m => m.markItemJunkNotJunkFromReadingPane
);

export let lazyMarkRowsAsPhishingFromTable = new LazyAction(
    lazyModule,
    m => m.markRowsAsPhishingFromTable
);

export let lazyMarkItemAsPhishingFromReadingPane = new LazyAction(
    lazyModule,
    m => m.markItemAsPhishingFromReadingPane
);
export let lazyRestoreMailListRowsAction = new LazyAction(lazyModule, m => m.restoreMailListRows);

export let lazyUnsubscribeEmail = new LazyAction(lazyModule, m => m.unsubscribeEmail);
export let lazyUnsubscribeEmailV2 = new LazyImport(lazyModule, m => m.unsubscribeEmailV2);

export let lazyBlockLastSendersFromTable = new LazyAction(
    lazyModule,
    m => m.blockLastSendersFromTable
);

export let lazyBlockLastSenderFromReadingPane = new LazyAction(
    lazyModule,
    m => m.blockLastSenderFromReadingPane
);

export let lazyAddCategoriesFromTable = new LazyAction(lazyModule, m => m.addCategoriesFromTable);

export let lazyRemoveCategoriesFromTable = new LazyAction(
    lazyModule,
    m => m.removeCategoriesFromTable
);

export let lazyClearCategoriesFromTable = new LazyAction(
    lazyModule,
    m => m.clearCategoriesFromTable
);

export let lazySweepConversations = new LazyAction(lazyModule, m => m.sweepConversations);
export let lazyEmptyFolder = new LazyAction(lazyModule, m => m.emptyFolder);
export let lazyEmptyTableView = new LazyAction(lazyModule, m => m.emptyTableView);
export let lazyEmptySearchTableView = new LazyAction(lazyModule, m => m.emptySearchTableView);
export let lazyToggleIgnoreConversations = new LazyImport(
    lazyModule,
    m => m.toggleIgnoreConversations
);
export let lazyMoveSharedFolderItems = new LazyImport(lazyModule, m => m.moveSharedFolderItems);
export let lazyMoveSharedFolderConversations = new LazyImport(
    lazyModule,
    m => m.moveSharedFolderConversations
);

export {
    ActionSource,
    ArchiveMailListRowsFromTableState,
    ClientItemId,
    DeleteItemFromReadingPaneState,
    EmailAddressWrapper,
    EmptyTableViewState,
    FocusedViewFilter,
    Folder,
    ItemId,
    InstrumentationContext,
    MailboxInfo,
    MarkItemJunkNotJunkFromReadingPaneState,
    Message,
    SweepOptionType,
    TableView,
    UnsubscribeEmailState,
};
export { getLastSenderMailboxesFromRowKeys } from './actions/helpers/getMailboxes';
export let lazyTranslateFromTable = new LazyAction(lazyModule, m => m.translateFromTable);
export {
    default as showNotificationOnMailboxQuotaWarning,
} from './actions/helpers/showNotificationOnMailboxQuotaWarning';
